<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthClient } from '@/stores/auth-store.ts'

defineOptions({ name: 'EmailVerification' })

const route = useRoute()
const router = useRouter()
const error = ref('')
const { acceptVerification } = useAuthClient()

onMounted(async () => {
  const token = route.query.token as string | undefined
  if (!token) return router.replace({ name: 'setup' })
  try {
    const res = await fetch(`/rpc/users/auth/verify?token=${encodeURIComponent(token)}`)
    const data = await res.json()
    if (!res.ok) throw new Error('This link is invalid or expired. Request another sign-in code.')
    acceptVerification(data)
    router.replace(route.query.reconnect === '1' ? '/' : '/setup')
  } catch (cause) {
    error.value = cause instanceof Error ? cause.message : 'Unable to verify. Please try again.'
  }
})
</script>

<template>
  <div class="mx-auto flex h-screen items-center justify-center">
    <div class="border rounded bg-base-200 px-16 py-10 text-center">
      <template v-if="error"
        >{{ error }}<br /><router-link to="/" class="btn mt-4">Return to app</router-link></template
      ><template v-else>Verifying—<br />Hold Tight...</template>
    </div>
  </div>
</template>
